<div class="modals" [class.condition-information-show]="isModalConditionsInformation">
  <a class="close-modal" (click)="closeModal()"></a>

  <h4 class="head-text">Правова інформація та умови використання сайту</h4>

  <div class="row column">
    <a class="alert" (click)="closeModal(); openOfertaModal()">Оферта (Угода користувача)</a>
  </div>
  <div class="row column">
    <a class="alert" (click)="closeModal(); openOfertaCookieModal()">Політика щодо використання файлів cookie</a>
  </div>
  <div class="row column">
    <a class="alert" (click)="closeModal(); openMainPositionModal()">Політика конфіденційності</a>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
